export default __webpack_public_path__ + "static/media/Inklink Video Background.1e913c7c.jpg";